/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_GeneratingInputs */

const zh_print_generating = /** @type {(inputs: Print_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成 PDF...`)
};

const en_print_generating = /** @type {(inputs: Print_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating PDF...`)
};

const es_print_generating = /** @type {(inputs: Print_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando PDF...`)
};

/**
* | output |
* | --- |
* | "Generating PDF..." |
*
* @param {Print_GeneratingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_generating = /** @type {((inputs?: Print_GeneratingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_GeneratingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_generating(inputs)
	if (locale === "en") return en_print_generating(inputs)
	return es_print_generating(inputs)
});